import config from "next/config";

import { call, select } from "@/redux/typed-saga-effects";
import { redirectToDashboard } from "@/utils/redirects";

import type { RootState } from "./store";

const { publicRuntimeConfig } = config();

export function* fetchAuthenticated<T>(
  url: string,
  method = "GET",
  token: string,
  body?: any,
  throwErrorResponse = false
) {
  const res = yield* call(() =>
    fetch(url, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
  );
  if (res.status === 401) {
    yield* call(redirectToDashboard);
    return;
  }
  if (res.status === 204) {
    return null;
  }
  if (!res.ok) {
    if (throwErrorResponse) {
      const errors = yield* call(() => res.json());
      throw errors;
    }
    throw new Error(res.status.toString());
  }

  return yield* call(() => res.json() as Promise<T>);
}

export function* fetchContentApi<T>(route: string, method = "GET", body?: any) {
  const auth = yield* select(
    (state: RootState) => state.contentHub.authentication
  );

  const apiRoot =
    publicRuntimeConfig.CONTENT_API_HOST || auth.contentApiEndpoint;

  return yield* call(() =>
    fetchAuthenticated<T>(
      `${apiRoot}${route}`,
      method,
      auth.contentApiAuthToken,
      body,
      true
    )
  );
}

export function* uploadMedia(url: string, file: File) {
  const res = yield* call(() =>
    fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file,
    })
  );

  if (!res.ok) {
    throw new Error(res.status.toString());
  }

  return yield* call(() => res);
}
